import OnUpdate from './OnUpdate';
import requestNextFrame from './requestNextFrame';

const ComponentRegistry = (function () {
	let all_elements = [];

	let _private = {
		hasInstance: function ($element, construct) {
			return _private.getInstance($element, construct) !== undefined;
		},
		getInstance: function ($element, construct) {
			let element = $element.get(0);

			if (!element.elkitorg_components) {
				return undefined;
			}

			return element.elkitorg_components.get(construct);
		},
		setInstance: function ($element, constructor, instance) {
			let element = $element.get(0);

			if (!element.elkitorg_components) {
				element.elkitorg_components = new Map();
				all_elements.push(element);
			}

			element.elkitorg_components.set(constructor, instance);
		},
		destroyInstances: function ($element) {
			let element = $element.get(0);

			if (!element.elkitorg_components) {
				return;
			}

			for (let instance of element.elkitorg_components.values()) {
				if (typeof instance.destruct !== 'function') {
					continue;
				}

				instance.destruct();
			}

			all_elements = all_elements.filter(el => el !== element);
		}
	};

	OnUpdate(function () {
		all_elements.forEach(function (element) {
			if (document.body.contains(element)) {
				return;
			}

			let $element = $(element);
			_private.destroyInstances($element);
		});
	});

	return {
		register: function (find, construct) {
			let getInstance = function ($element) {
				if ($element.length !== 1) {
					console.error('not valid count elements: ' + $element.length);
					return;
				}

				if (!_private.hasInstance($element, construct)) {
					let instance = {};
					let destructor = construct($element, instance);

					if (typeof destructor === 'function') {
						instance.destruct = destructor;
					}

					_private.setInstance($element, construct, instance);
				}

				return _private.getInstance($element, construct);
			};

			if (typeof find === 'function') {
				let initInContext = function ($context) {
					let $elements = find($context);

					$elements.each(function () {
						let $element = $(this);

						requestNextFrame(() => getInstance($element));
					});
				};
				OnUpdate(initInContext);

				try {
					initInContext($(document.body));
				} catch (e) {
					console.error(e);
				}
			}

			return getInstance;
		}
	};
})();

export default ComponentRegistry;
